import React from 'react'
import styles from './ScoutOffer.module.css'
import { ScoutOfferProps } from './types'
import { useAbTestGtm } from '@/components/utils/abTest'
import { CtaButton } from './CtaButton'

const IMAGE_DIR = '/pages/thanks/scout_offer'
// 上下2つのCTAは同じ帯画像（オレンジの余白＋白地だけ。ボタンはHTMLで重ねる）を共有する
const CTA_BG_SRC = `${IMAGE_DIR}/cta_bg.png`

// 登録が続いているように見せ（次のステップ）、自然にPF転換へ誘導する。
// DEV-3392のCパターンをDEV-3586で全流入に恒久反映したもの。
export const ScoutOffer = ({ telImageSrc, upgradeUrl }: ScoutOfferProps) => {
    const { dataViewLabel, dataClickLabel } = useAbTestGtm()

    return (
        <div className={styles.body}>
            <img
                src={`${IMAGE_DIR}/head.png`}
                alt='ご登録ありがとうございます！今すぐ転職を考えていない場合は、ご相談だけでも歓迎！'
                className={styles.strip}
            />
            <div className={styles.telRow}>
                <img src={telImageSrc} alt='TEL画像' className={styles.telImage} />
            </div>
            <div data-view-label={dataViewLabel('Thanks_CT_スカウト')}>
                <div data-view-label={dataViewLabel('Thanks_CT_スカウト_コンテンツ1')}>
                    <img
                        src={`${IMAGE_DIR}/step.png`}
                        alt='次のステップ：STEP1 会員登録完了、STEP2 プロフィール登録、STEP3 転職開始'
                        className={styles.strip}
                    />
                </div>
                <CtaButton
                    bgSrc={CTA_BG_SRC}
                    bgWidth={750}
                    bgHeight={182}
                    button={{ x: 75, y: 62, w: 600, h: 104 }}
                    text='プロフィール登録へ進む'
                    href={upgradeUrl}
                    dataClickLabel={dataClickLabel('Thanks_CT_スカウト_CTAボタン1')}
                    badge={{ box: { x: 175, y: 12, w: 400, h: 62 }, text: '今なら3日間限定特典あり！' }}
                />
                <img
                    src={`${IMAGE_DIR}/benefit.png`}
                    alt='プロフィール登録でできること：スカウトが届く、求人が保存できる、求人のレコメンド'
                    className={styles.strip}
                />
                <div data-view-label={dataViewLabel('Thanks_CT_スカウト_コンテンツ2')}>
                    <img
                        src={`${IMAGE_DIR}/benefit4.png`}
                        alt='ワンクリックでかんたん応募'
                        className={styles.strip}
                    />
                </div>
                <CtaButton
                    bgSrc={CTA_BG_SRC}
                    bgWidth={750}
                    bgHeight={182}
                    button={{ x: 75, y: 66, w: 600, h: 104 }}
                    text='プロフィール登録へ進む'
                    href={upgradeUrl}
                    dataClickLabel={dataClickLabel('Thanks_CT_スカウト_CTAボタン2')}
                    badge={{ box: { x: 111, y: 16, w: 526, h: 62 }, text: 'あと2分で全ての機能が使えるようになります' }}
                />
                <img src={`${IMAGE_DIR}/tail.png`} alt='' className={styles.strip} />
            </div>
        </div>
    )
}

export default ScoutOffer
